import { apiPaths } from "@/lib/api/paths";
import { apiClient } from "@/lib/api/client";
import type {
  UploadProfilePictureDTO,
  UploadProfilePictureResponse,
} from "./type";

export async function uploadProfilePicture(
  profile: UploadProfilePictureDTO,
): Promise<UploadProfilePictureResponse> {
  const formData = new FormData();
  formData.append("file", profile.file);

  const response = await apiClient.patch<UploadProfilePictureResponse>(
    apiPaths.users.updateProfilePicture(profile.userId),
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    },
  );

  return response.data;
}
